module.exports = __webpack_public_path__ + "img/JCB_60x36.0450a829.jpg";